import React, {
  Component,
  ComponentType,
  ExoticComponent,
  FC,
  NamedExoticComponent,
  ReactElement,
  useMemo,
  useState,
} from 'react';
import {Tabs, TabPanel} from 'react-tabs';

import {LmtSponsor, MatchResult, MatchSimple, Probabilities, Sport, Team, TeamInfo, TeamRankings, TimelineUpdate} from '../../../utils/types';

import PillTabList from '../../Common/PillTabList';
import AsyncWidgetStats from '../../Async/AsyncWidgetStats';
import AsyncWidgetLineups from '../../Async/AsyncWidgetLineups';

import './styles.scss';
import WidgetSrStandings from '../WidgetSrStandings';
import WidgetSrLineups from '../WidgetSrLineups';
import WidgetSrStats from '../WidgetSrStats';
import WidgetPreview from '../WidgetPreview';

interface Props {
  sport: Sport;
  teams: {
    home: TeamInfo;
    away: TeamInfo;
  };
  matchId: string;
  updates: TimelineUpdate[];
  srId: string;
  seasonId?: string;
  lmtSponsor?: LmtSponsor;
  AsyncWidgetStatsRenderer?: typeof AsyncWidgetStats;
  AsyncWidgetLineupsRenderer?: typeof AsyncWidgetLineups;
  teamRankings?: TeamRankings
  probabilities?: Probabilities
  formaMatches?: MatchSimple[]
  formaHome?: MatchResult[]
  formaAway?: MatchResult[]

}

const PanelLineupsStats: FC<Props> = ({
  sport,
  teams,
  matchId,
  updates,
  srId,
  seasonId,
  lmtSponsor,
  AsyncWidgetStatsRenderer = AsyncWidgetStats,
  AsyncWidgetLineupsRenderer = AsyncWidgetLineups,
  teamRankings,
  probabilities,
  formaMatches,
  formaHome,
  formaAway,

}: Props) => {
  const [selectedTab, setSelectedTab] = useState(1);

  // const tabs = useMemo(
  //   () => [`LINEUP ${teams.home.shortName}`, 'STATS', `LINEUP ${teams.away.shortName}`],
  //   [teams]
  // );

  const tabs = useMemo(
    () => [`PREVIEW`, 'LIVE STANDINGS'],
    [teams]
  );

  return sport === Sport.SOCCER ? (
    <Tabs
      className="PanelLineupsStats"
      selectedIndex={selectedTab}
      onSelect={(index, prevIndex) => index !== prevIndex && setSelectedTab(index)}
    >
      {
        PillTabList({
          tabs,
        }) /* component used as a function due to issue https://github.com/reactjs/react-tabs/issues/208 */
      }
      {/* <TabPanel>
        <WidgetSrLineups srId={srId} seasonId={seasonId} lmtSponsor={lmtSponsor}/>
      </TabPanel> */}
      <TabPanel>
        <WidgetPreview
          sport={sport}
          teams={teams}
          teamRankings={teamRankings}
          probabilities={probabilities}
          formaMatches={formaMatches}
          formaHome={formaHome}
          formaAway={formaAway}
        />
      </TabPanel>
      <TabPanel>

        <WidgetSrStandings srId={srId} seasonId={seasonId} lmtSponsor={lmtSponsor}/>
      </TabPanel>
    </Tabs>
  ) : (
    <div className="PanelLineupsStats">
      <AsyncWidgetStats matchId={matchId} teams={teams} />
    </div>
  );
};

export default React.memo(PanelLineupsStats);
